import styled from 'styled-components';
import LoaderAnimation from '../components/LoaderAnimation';

const Body = styled.div(({ theme }) => {
  const { color } = theme;
  return `
    position: absolute;
    top: 0px;
    left: 0px;
    display: flex;
    justify-content:center;
    align-items:center;
    min-height: 100%;
    min-width: 100%;
    z-index: 0;
    background: ${color.grayscale[900]}
`;
});

const LoaderPage = () => {
  return (
    <Body>
      <LoaderAnimation />
    </Body>
  );
};

export default LoaderPage;
